import React from 'react';
import useHttp from '../../../hooks/http.hook';
import { useNavigate } from 'react-router-dom';
import { DeleteProductModal, ProductRow } from './product_item_components';

function ProductItem({ product, onDeleted, onVariantDeleted }) {
  const { loading, requestWithMeta } = useHttp();
  const navigate = useNavigate();
  const [isDeleteOpen, setIsDeleteOpen] = React.useState(false);
  const [deleteError, setDeleteError] = React.useState(null);
  const [isDeleteVariantOpen, setIsDeleteVariantOpen] = React.useState(false);
  const [activeVariant, setActiveVariant] = React.useState(null);
  const [variantError, setVariantError] = React.useState(null);

  React.useEffect(() => {
    if (!isDeleteOpen) return;
    setDeleteError(null);
  }, [isDeleteOpen]);

  React.useEffect(() => {
    if (!isDeleteVariantOpen) return;
    setVariantError(null);
  }, [isDeleteVariantOpen]);

  function handleEdit() {
    const productId = product?._id ?? product?.id;
    if (!productId) return;
    navigate(`/product/${productId}/edit`, { state: { product } });
  }

  function handleAddVariant() {
    const productId = product?._id ?? product?.id;
    if (!productId) return;
    navigate(`/product/${productId}/variant/create`, { state: { product } });
  }

  function handleEditVariant(variant) {
    const productId = product?._id ?? product?.id;
    const variantId = variant?._id ?? variant?.id;
    if (!productId || !variantId) return;
    navigate(`/product/${productId}/variant/${variantId}/edit`, {
      state: { product, variant },
    });
  }

  function handleDeleteVariant(variant) {
    setActiveVariant(variant);
    setIsDeleteVariantOpen(true);
  }

  async function handleConfirmDelete() {
    setDeleteError(null);
    const productId = product?._id ?? product?.id;
    if (!productId) {
      setDeleteError('Не найден идентификатор товара');
      return;
    }

    const res = await requestWithMeta('/operator/products', 'DELETE', { productId });
    if (!res?.ok) {
      setDeleteError(res?.data?.error || res?.data?.message || 'Не удалось удалить товар');
      return;
    }

    onDeleted?.(productId);
    setIsDeleteOpen(false);
  }

  async function handleConfirmDeleteVariant() {
    setVariantError(null);
    const variantId = activeVariant?._id ?? activeVariant?.id;
    const groupId = product?._id ?? product?.id;
    if (!variantId || !groupId) {
      setVariantError('Не найден идентификатор варианта');
      return;
    }

    const res = await requestWithMeta('/operator/products/variants', 'DELETE', { variantId });
    if (!res?.ok) {
      setVariantError(res?.data?.error || res?.data?.message || 'Не удалось удалить вариант');
      return;
    }

    onVariantDeleted?.(groupId, variantId);
    setIsDeleteVariantOpen(false);
    setActiveVariant(null);
  }

  const activeVariantLabel =
    String(activeVariant?.title ?? '').trim() || 'Обычный';

  return (
    <>
      <ProductRow
        product={product}
        onEdit={handleEdit}
        onDelete={() => setIsDeleteOpen(true)}
        onAddVariant={handleAddVariant}
        onEditVariant={handleEditVariant}
        onDeleteVariant={handleDeleteVariant}
      />

      <DeleteProductModal
        isOpen={isDeleteOpen}
        onClose={() => setIsDeleteOpen(false)}
        productName={product?.name}
        deleteError={deleteError}
        loading={loading}
        onConfirmDelete={handleConfirmDelete}
      />

      <DeleteProductModal
        isOpen={isDeleteVariantOpen}
        onClose={() => {
          setIsDeleteVariantOpen(false);
          setActiveVariant(null);
        }}
        title="Удалить вариант"
        productName={activeVariantLabel}
        deleteError={variantError}
        loading={loading}
        onConfirmDelete={handleConfirmDeleteVariant}
      />
    </>
  );
}

export default ProductItem;
